import EmployeeHttp from '../services/http/EmployeeHttp';
import { createImmutableDataFetchStore } from '../utilities/ImmutableDataFetchStore';

export const useEmployeeStore = createImmutableDataFetchStore((p: { organizationId: string }) =>
  new EmployeeHttp().get({ 'group.organizationId': p.organizationId })
);
